import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { IoClose } from "react-icons/io5";

export default function HardwareSelectTable(props) {

    // console.log("props at ", props);

    const handleInputChange = (event, params) => {
        const newSelection = [...props.selected];
        const existingIndex = newSelection.findIndex((item) => item.hardware_id === params.row.hardware_id);
        if (existingIndex === -1) {
            newSelection.push({ ...params.row, quantity: 1 });
        } else {
            if (/^\d*$/.test(event.target.value)) {

                newSelection[existingIndex].quantity = event.target.value;
            }
        }
        props.setSelectedDevice(newSelection);
    }


    const getDiscount=(id)=>{
      return  props.selected.find((item) => item.hardware_id === id) && props.selected.find((item) => item.hardware_id === id).rm_discount  ? props.selected.find((item) => item.hardware_id === id).rm_discount : 0
    }


    console.log("props at approval",props);
    

    const columns = [
        //   { field: 'id', headerName: 'ID', width: 70 },
        { field: 'bank_name', headerName: 'Bank Name', width: 200 },
        { field: 'name', headerName: 'Device', width: 130 },
        { field: 'brand_name', headerName: 'Brand', width: 130 },
        { field: 'model', headerName: 'Modal No', width: 130 },
        {
            field: 'quantity', headerName: 'Quantity', width: 130, renderCell: (params) => (
                <TextField
                    variant="outlined"
                    disabled
                    value={
                        props.selected.find((item) => item.hardware_id === params.row.hardware_id) ? props.selected.find((item) => item.hardware_id === params.row.hardware_id).quantity : null
                    }

                    size='small'
                    onChange={(event) => handleInputChange(event, params)}
                />
            ),
        },
        { field: 'amount', headerName: 'Price per unit', width: 200 },
        {
            field: 'sh_amount',
            headerName: 'Total Amount',
            width: 150,
            renderCell: (params) => (
                <TextField
                    variant="outlined"
                    disabled
                    value={
                        eval((props.selected.find((item) => item.hardware_id === params.row.hardware_id) ? props.selected.find((item) => item.hardware_id === params.row.hardware_id).quantity : 1) * (params.row.amount))
                    }

                    size='small'
                    onChange={(event) => handleInputChange(event, params)}
                />
            ),
        },

    ];

    const columns2 = [
        //   { field: 'id', headerName: 'ID', width: 70 },
          { field: 'bank_name', headerName: 'Bank Name', width: 200 },
          { field: 'name', headerName: 'Device', width: 130 },
          { field: 'brand_name', headerName: 'Brand', width: 130 },
          { field: 'model', headerName: 'Modal No', width: 130 },
          { field: 'quantity', headerName: 'Quantity', width: 130 },
          { field: 'amount', headerName: 'Price per unit', width: 200 },
          {
            field: 'discount',
            headerName: 'Add Discount',
            width: 150,
            renderCell: (params) => (
              <TextField
                variant="outlined"
                disabled
                value={
                    props.selected.find((item) => item.hardware_id === params.row.hardware_id) && props.selected.find((item) => item.hardware_id === params.row.hardware_id).rm_discount ? props.selected.find((item) => item.hardware_id === params.row.hardware_id)?.rm_discount : "0"
                }
                size='small'
              />
            ),
          },
          {
            field: 'sh_amount',
            headerName: 'Total Amount',
            width: 150,
            renderCell: (params) => (
              <TextField
                variant="outlined"
                value={
                    eval(((props.selected.find((item) => item.hardware_id === params.row.hardware_id) ? props.selected.find((item) => item.hardware_id === params.row.hardware_id).quantity : 1) * (params.row.amount))-(getDiscount(params.row.hardware_id)))
                }
               disabled
                size='small'
              />
            ),
          },
         
        ];


        // console.log("props at device",props);
        

    const getData = () => {

        let row = props.data[0].hardware_data.filter((item) =>
            props.selected.some(selectedItem => selectedItem.hardware_id === item.hardware_id)
        );
        return row
    }

    const handleApproveRequest=()=>{
        props.handleSubmit()
    }

    const paginationModel = { page: 0, pageSize: 5 };

    const NoRowsOverlay = () => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <Typography variant="body2" color="textSecondary">No rows</Typography>
        </div>
      );


    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth={props.selected&&props.selected.length>0?"lg":"xs"}
            >
                <Box sx={{position:'absolute',top:5,right:5,fontSize:'25px',cursor:'pointer'}} onClick={()=>props.handleClose()}>
                    <IoClose />

                </Box>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {
                            props.data && props.data.length>0 &&props.selected&&props.selected.length> 0 ?
                             <DataGrid
                             rows={props.data && props.data.length > 0 ? getData() : []}
                             columns={sessionStorage.getItem("UserType")==="ph"?columns:columns2}
                             initialState={{ pagination: { paginationModel } }}
                             pageSizeOptions={[5, 10]}
                             slots={{
                                 noRowsOverlay: NoRowsOverlay,
                             }}
                             getRowId={(row) => row.hardware_id}
                             sx={{ border: 0 ,minHeight:200}}
                         />
                         :
                         "Confirm Approve all the devices"
                        }
                       
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid style={{ width: '100%' }} container justifyContent='center' alignItems='center'>
                        <Grid item xl={2} lg-={2} md={2} sm={2} xs={12}>
                            {
                                props.isLoading ?
                                <Button disabled fullWidth variant='contained' color='secondary' >
                                    Loading...
                                </Button>
                                :
                                <Button fullWidth variant='contained' color='secondary' onClick={()=>handleApproveRequest()}>
                                    Proceed
                                </Button>

                            }
                            
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
